import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useT } from "../../shared/i18n";
import { usePreferencesStore } from "../../shared/store/preferences";
import { SCANNER_DISPLAY_KEYS, ScanStage, type ScanStageProps } from "./ScanStage";

/**
 * The small viewfinder chip plus its scanning caption, used by the dialog
 * presets (`container-add`, `item-create`, `identify`). Dialogs get the same
 * 112 px stage and the shared persisted display mode, but no aiming control.
 */
export function ScanChip({ hidden = false, ...stage }: ScanStageProps) {
  const t = useT();
  const display = usePreferencesStore((state) => state.scannerDisplay);

  return (
    <Stack
      data-testid="scan-chip"
      direction="row"
      spacing={1.5}
      alignItems="center"
      sx={{ display: hidden ? "none" : "flex" }}
    >
      <ScanStage {...stage} hidden={hidden} />
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
          {stage.cameraError ? t("scanCameraUnavailable") : t("scanScanning")}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
          {t(SCANNER_DISPLAY_KEYS[display])}
        </Typography>
      </Box>
    </Stack>
  );
}
